module.exports = __webpack_public_path__ + "static/media/glyphicons-halflings-regular.e18bbf61.ttf";